import { defaultRecipe, validateRecipe, plainObject, exactKeys, type ImageRecipe } from './recipe.js';
export type Theme = 'system' | 'light' | 'dark';
export type Preferences = { recipe: ImageRecipe; theme: Theme };
import { PREFERENCES_KEY } from './storage-keys.js';
export { PREFERENCES_KEY } from './storage-keys.js';
export function readPreferences(storage: Pick<Storage, 'getItem'>): Preferences {
  const defaults = { recipe: defaultRecipe(), theme: 'system' as const };
  try {
    const raw = storage.getItem(PREFERENCES_KEY); if (!raw || raw.length > 4096) return defaults;
    const p = plainObject(JSON.parse(raw), 'Preferences');
    exactKeys(p, ['version', 'recipe', 'theme'], 'Preferences');
    if (p.version !== 1 || !['system', 'light', 'dark'].includes(p.theme as string)) return defaults;
    return { recipe: validateRecipe(p.recipe), theme: p.theme as Theme };
  } catch { return defaults; }
}
export function writePreferences(storage: Pick<Storage, 'setItem'>, p: Preferences): boolean {
  try {
    if (!['system', 'light', 'dark'].includes(p.theme)) return false;
    const raw = JSON.stringify({ version: 1, recipe: validateRecipe(p.recipe), theme: p.theme });
    if (raw.length > 4096) return false;
    storage.setItem(PREFERENCES_KEY, raw); return true;
  } catch { return false; }
}
